// sidebarSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  setCollapsed: false,
  isVisible: true,
  accountingOnboardingStatus: null,
};

export const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setCollapsed: (state, action) => {
      state.setCollapsed = action.payload;
    },
    setIsVisible: (state, action) => {
      state.isVisible = action.payload;
    },
    setAccountingOnboardingStatus: (state, action) => {
      state.accountingOnboardingStatus = action.payload;
    },
  },
});

export const { setAccountingOnboardingStatus, setCollapsed, setIsVisible } = sidebarSlice.actions;
